import { InjectionToken } from '@angular/core';
import { NapaFormTracker } from '../models/form-tracker.models';
import { NapaFormTrackersGroup } from '../models/form-trackers-group.models';

export const NAPA_FORM_TRACKER: InjectionToken<NapaFormTracker> = new InjectionToken('NAPA_FORM_TRACKER');

export const NAPA_FORM_TRACKERS_GROUP: InjectionToken<NapaFormTrackersGroup> = new InjectionToken(
  'NAPA_FORM_TRACKERS_GROUP'
);
